import { all } from "redux-saga/effects";
import { getAdminWatcherSaga, getAdminOTPWatcherSaga } from "./Auth/sagas";
import {
	getExtrenalUserWatcherSaga,
	deleteExtrenalUserWatcherSaga,
} from "./ExternalUser/sagas";
import {
	getExternalUserSubUserWatcherSaga,
	deleteExternalUserSubUserWatcherSaga,
} from "./ExternalUserSubUser/sagas";
import {
	getInternalUserWatcherSaga,
	deleteInternalUserWatcherSaga,
} from "./InternalUser/sagas";

import {
	getEmployeeWatcherSaga,
	createEmployeeWatcherSaga,
	deleteEmployeeWatcherSaga,
	updateEmployeeWatcherSaga,
} from "./Employee/sagas";

import {
	getCustomerWatcherSaga,
	// createCustomerWatcherSaga,
	deleteCustomerWatcherSaga,
	// updateCustomerWatcherSaga,
} from "./Customer/sagas";
import {
	getequipmentsWatcherSaga,
	deleteequipmentsWatcherSaga,
} from "./Equipment/sagas";
import {
	getFromBuilderWatcherSaga,
	createFromBuilderWatcherSaga,
	deleteFromBuilderWatcherSaga,
	updateFromBuilderWatcherSaga,
	getSingleFromBuilderWatcherSaga,
	getFormByTitleWatcherSaga,
	getFormsByTitleWatcherSaga,
} from "./FromCreator/sagas";

import { getadminFormBuilderWatcherSaga } from "./AdminFormList/sagas";
import { getClientFormBuilderWatcherSaga } from "./ClientFormList/sagas";
import {
	getMethodWatcherSaga,
	deleteMethodWatcherSaga,
	getMethodFormWatcherSaga,
	updateMethodFormWatcherSaga,
} from "./Method/sagas";
import {
	getSampleNameWatcherSaga,
	// createSampleNameWatcherSaga,
	deleteSampleNameWatcherSaga,
	updateSampleNameWatcherSaga,
	// updateSampleNameWatcherSaga,
} from "./SampleName/sagas";

import {
	getsamplelistWatcherSaga,
	// createSampleNameWatcherSaga,
	deleteSampleListWatcherSaga,
	// updateSampleNameWatcherSaga,
} from "./SampleList/sagas";

import {
	getmenuWatcherSaga,
	getpagesWatcherSaga,
	createpagesWatcherSaga,
	deletepagesWatcherSaga,
	updatepagesWatcherSaga,
	createNewVersionpagesWatcherSaga,
} from "./Pages/sagas";

import {
	getcolumnListWatcherSaga
} from './ColumnSetList/sagas';

import {
	getrolesandpermissionWatcherSaga,
	deleterolesandpermissionWatcherSaga,
} from "./Roles&permission/sagas";

import {
	createTemplateStartWatcherSaga,
	templateListStartWatcherSaga,
	deleteTemplateStartWatcherSaga,
	templateDetailsStartWatcherSaga,
	updateTemplateStartWatcherSaga,
	generatePdfAndSendEmailStartWatcherSaga,
	duplicateTemplateStartWatcherSaga,
} from "./ReportBuilder/sagas";

import {
	getcustomerOrderWatcherSaga,
	deletecustomerOrderWatcherSaga,
} from "./CustomerOrder/sagas";

import {
	getservicesWatcherSaga,
	deleteservicesWatcherSaga,
} from "./service/sagas";

import {
	getworkOrderWatcherSaga,
	deleteworkOrderWatcherSaga,
} from "./WorkOrder/sagas";

import {
	getManageJobWatcherSaga,
	deleteManageJobWatcherSaga,
} from "./ManageJob/sagas";

import { getjobWatcherSaga, getMasterJobWatcherSaga } from "./Job/sagas";
import { getdataEntryWatcherSaga } from "./DataEntry/sagas";

import {
	getequipmetsServiceWatcherSaga,
	createequipmetsServiceWatcherSaga,
	deleteequipmetsServiceWatcherSaga,
	updateequipmetsServiceWatcherSaga,
} from "./EquipmentService/sagas";

import {
	getexpiredItemsWatcherSaga,
	deleteexpiredItemsWatcherSaga,
} from "./ExpiredItems/sagas";

import {
	getreagentsWatcherSaga,
	deletereagentsWatcherSaga,
} from "./ReagentsAndChemicals/sagas";

import {
	getstoreWatcherSaga,
	deletestoreWatcherSaga,
} from "./StoreReducer/sagas";

import { getreportsWatcherSaga } from "./Reports/sagas";

import {
	getgroupsWatcherSaga,
	getmanageGroupsWatcherSaga,
	getGroupTechnicianListsWatcherSaga,
} from "./Groups/sagas";
import {
	getCalibrationWatcherSaga,
	deleteCalibrationWatcherSaga,
} from "./Calibration/sagas";
import {
	getMaintenanceWatcherSaga,
	deleteMaintenanceWatcherSaga,
} from "./Maintenance/sagas";

import {
	getsubscriberWatcherSaga,
	deletesubscriberWatcherSaga,
} from "./subscriber/sagas";

import {
	getsubscriptionplanWatcherSaga,
	deletesubscriptionplanWatcherSaga,
} from "./subscriptionPlan/sagas";

import {
	getCmsPageListWatcherSaga,
	deleteCmsPageListWatcherSaga,
} from "./PageList/sagas";

import {
	getcontentPageWatcherSaga,
	deletecontentPageWatcherSaga,
} from "./PageContent/sagas";

import {
	getsiteSettingWatcherSaga,
	deletesiteSettingWatcherSaga,
} from "./SiteSetting/sagas";

import {
	getgeneralInventoryWatcherSaga,
	deletegeneralInventoryWatcherSaga,
} from "./GeneralInventory/sagas";

import {
	getuserProfileWatcherSaga,
	deleteuserProfileWatcherSaga,
} from "./UserProfile/sagas";

import { getEmployeeFormBuilderWatcherSaga } from "./EmployeeFormList/sagas";
import {
	getEmployeeDetailsWatcherSaga,
	deleteEmployeeDetailsWatcherSaga,
} from "./EmployeeDetails/sagas";

import {
	getNonConfirmityReportWatcherSaga,
	getOneNonConformityReportWatcherSaga,
	deleteNonConfirmityReportWatcherSaga,
} from "./NonConformityReport/sagas";

import {
	getNonConfirmityReportTicketWatcherSaga,
	deleteNonConfirmityReportTicketWatcherSaga,
} from "./NonConformityTicketReview/sagas";

import {
	getEntityListStartWatcherSaga,
	getEntityByIdStartWatcherSaga,
	addRuleToEntityStartWatcherSaga,
	updateRuleStartWatcherSaga,
} from "./IdentificationRules/sagas";

import { archieveBulkStartWatcherSaga } from "./Archieve/sagas";

import {
	getAccommodationWatcherSaga,
	deleteAccommodationWatcherSaga,
} from "./Accommodation/sagas";
import {
	getBuildingWatcherSaga,
	deleteBuildingWatcherSaga,
} from "./Building/sagas";

import {
	getClientDetailsWatcherSaga,
	deleteClientDetailsWatcherSaga,
} from "./ClientDetails/sagas";

import { getvendorWatcherSaga, deletevendorWatcherSaga } from "./vendor/sagas";
import { getVendorFormBuilderWatcherSaga } from "./VendorFormList/sagas";
import {
	getVendorDetailsWatcherSaga,
	deleteVendorDetailsWatcherSaga,
} from "./VendorDetails/sagas";

import {
	getapprovalListWatcherSaga,
	deleteapprovalListWatcherSaga,
} from "./Approvallist/sagas";

import {
	getvendorCategoriesWatcherSaga,
	deletevendorCategoriesWatcherSaga,
} from "./VendorCategories/sagas";

import {
	getsampleCategoriesWatcherSaga,
	deletesampleCategoriesWatcherSaga,
} from "./SampleCategories/sagas";

import {
	getvendorSubCategoriesWatcherSaga,
	deletevendorSubCategoriesWatcherSaga,
} from "./VendorSubCategories/sagas";

import {
	getdocumentsWatcherSaga,
	deletedocumentsWatcherSaga,
} from "./Document/sagas";

import {
	getDocumentCalibrationWatcherSaga,
	deleteDocumentCalibrationWatcherSaga,
} from "./DocumentCalibration/sagas";

import {
	getDocumentMaintenanceWatcherSaga,
	deleteDocumentMaintenanceWatcherSaga,
} from "./DocumentMaintenance/sagas";

import {
	getTechnicalDocumentWatcherSaga,
	deleteTechnicalDocumentWatcherSaga,
} from "./TechnicalDocument/sagas";

import {
	getStandardDocumentWatcherSaga,
	deleteStandardDocumentWatcherSaga,
} from "./StandardDocument/sagas";

import {
	getGeneralDocumentWatcherSaga,
	deleteGeneralDocumentWatcherSaga,
} from "./GeneralDocument/sagas";

import {
	getPrivateDocumentWatcherSaga,
	deletePrivateDocumentWatcherSaga,
} from "./PrivateDocument/sagas";

import {
	getCustomReportWatcherSaga,
	deleteCustomReportWatcherSaga,
} from "./CustomReports/sagas";
import {
	getQualityManagmentWatcherSaga,
	deleteQualityManagmentWatcherSaga,
} from "./QualityManagment/sagas";
import {
	getSubQualityManagmentWatcherSaga,
	deleteSubQualityManagmentWatcherSaga,
} from "./SubQualityManagment/sagas";
import {
	getQuality_ManualWatcherSaga,
	deleteQuality_ManualWatcherSaga,
} from "./QualityManual/sagas";

import {
	userActivityDetailsStartWatcherSaga,
	userActivityListStartWatcherSaga,
} from "./UserActivity/sagas";
import {
	getMasterNameListWatcherSaga,
	deleteMasterNameListWatcherSaga,
} from "./MasterNameList/sagas";

import {
	getLeadCustomerWatcherSaga,
	deleteLeadCustomerWatcherSaga,
} from "./LeadCustomer/sagas";

import {
	getDocumentListWatcherSaga,
	deleteDocumentListWatcherSaga,
} from "./ClientDocumentList/sagas";

import {
	getMethodPackagesWatcherSaga,
	deleteMethodPackagesWatcherSaga,
	getMethodPackagesFormWatcherSaga,
	updateMethodPackagesFormWatcherSaga,
} from "./MethodPackages/sagas";

import {
	getadminUserWatcherSaga,
	deleteadminUserWatcherSaga,
} from "./AdminUsers/sagas";

import {
	getmanagementReviewWatcherSaga,
	deletemanagementReviewWatcherSaga,
} from "./ManagementReview/sagas";

import {
	getinternalAuditWatcherSaga,
	deleteinternalAuditWatcherSaga,
} from "./InternalAudit/sagas";

import {
	getexternalAuditWatcherSaga,
	deleteexternalAuditWatcherSaga,
} from "./ExternalAudit/sagas";

import {
	gettraningWatcherSaga,
	deletetraningWatcherSaga,
} from "./Traning/sagas";

import {
	getplanTrainingWatcherSaga,
	deleteplanTrainingWatcherSaga,
} from "./PlanTraining/sagas";

import {
	getmanage_participantsWatcherSaga,
	deletemanage_participantsWatcherSaga,
} from "./ManageParticipants/sagas";

import {
	getintraLabProgramWatcherSaga,
	deleteintraLabProgramWatcherSaga,
} from "./IntraLaboratoryProgram/sagas";
import {
	deleteinterLabProgramWatcherSaga,
	getinterLabProgramWatcherSaga,
} from "./InterLaboratoryProgram/sagas";

import {
	getptProgramWatcherSaga,
	deleteptProgramWatcherSaga,
} from "./PTProgram/sagas";

import {
	getcomplainWatcherSaga,
	deletecomplainWatcherSaga,
} from "./complains/sagas";

import {
	getsuggestionWatcherSaga,
	deletesuggestionWatcherSaga,
} from "./suggestion/sagas";

import {
	getcustomer_surveyWatcherSaga,
	deletecustomer_surveyWatcherSaga,
} from "./customersurvey/sagas";

import {
	getemployee_evaluationWatcherSaga,
	deleteemployee_evaluationWatcherSaga,
} from "./EmployeeEvaluation/sagas";
import {
	getvendor_evaluationWatcherSaga,
	deletevendor_evaluationWatcherSaga,
} from "./VendorEvaluation/sagas";

import {
	getequipment_evaluationWatcherSaga,
	deleteequipment_evaluationWatcherSaga,
} from "./EquipmentEvaluation/sagas";
import {
	getclient_evaluationWatcherSaga,
	deleteclient_evaluationWatcherSaga,
} from "./ClientEvaluation/sagas";
import {
	getclient_projectsWatcherSaga,
	deleteclient_projectsWatcherSaga,
} from "./ClientProjects/sagas";
import {
	getrecurringsurveyWatcherSaga,
	deleterecurringsurveyWatcherSaga,
} from "./RecurringSurvey/sagas";

import { deleteTechnicianWatcherSaga, getTechnicianWatcherSaga } from "./Technicians/sagas";
import { deletecrmWatcherSaga, getcrmWatcherSaga } from "./CertifiedReferenceMaterial/sagas";
import { deletecalibrationdevicesWatcherSaga, getcalibrationdevicesWatcherSaga } from "./CalibrationDevices/sagas";
import { getOrganizationProfileFormBuilderWatcherSaga } from "./OrganizationProfileFormList/sagas";
import {getPublicProfileFormBuilderWatcherSaga} from "./PublicFormList/sagas";
import { getEquipmentFormBuilderWatcherSaga } from "./EquipmentFormList/sagas";
import { deleteRequestWatcherSaga, getRequestWatcherSaga,updateRequestWatcherSaga } from "./Request/sagas";
import { deleteLabVisitorWatcherSaga, getLabVisitorWatcherSaga, updateLabVisitorWatcherSaga } from "./LabVisitor/sagas";
import { deleteLogWatcherSaga, getLogWatcherSaga } from "./Log/sagas";
import { deleteQuotationWatcherSaga, getQuotationWatcherSaga, updateQuotationWatcherSaga } from "./Quotation/sagas";
import { getClientRequestWatcherSaga, deleteClientRequestWatcherSaga, getSingleClientRequestWatcherSaga } from "./ClientRequest/sagas";
import { deletePoWatcherSaga, getPoWatcherSaga, updatePoWatcherSaga } from "./Po/sagas";
export default function* root() {
	yield all([
		getAdminWatcherSaga(),
		getAdminOTPWatcherSaga(),
		//External User
		getExtrenalUserWatcherSaga(),
		deleteExtrenalUserWatcherSaga(),

		//External User Sub User
		getExternalUserSubUserWatcherSaga(),
		deleteExternalUserSubUserWatcherSaga(),

		//internal User
		getInternalUserWatcherSaga(),
		// createInternalUserWatcherSaga(),
		deleteInternalUserWatcherSaga(),
		// updateInternalUserWatcherSaga(),
		//employee
		getEmployeeWatcherSaga(),
		createEmployeeWatcherSaga(),
		deleteEmployeeWatcherSaga(),
		updateEmployeeWatcherSaga(),
		//customer
		getCustomerWatcherSaga(),
		// createCustomerWatcherSaga(),
		deleteCustomerWatcherSaga(),
		// updateCustomerWatcherSaga(),
		//equipment
		getequipmentsWatcherSaga(),
		deleteequipmentsWatcherSaga(),

		//from builder
		getFromBuilderWatcherSaga(),
		createFromBuilderWatcherSaga(),
		deleteFromBuilderWatcherSaga(),
		updateFromBuilderWatcherSaga(),
		getSingleFromBuilderWatcherSaga(),
		getFormByTitleWatcherSaga(),
		getFormsByTitleWatcherSaga(),
		//admin form
		getadminFormBuilderWatcherSaga(),
		getClientFormBuilderWatcherSaga(),

		//method
		getMethodWatcherSaga(),
		deleteMethodWatcherSaga(),
		getMethodFormWatcherSaga(),
		updateMethodFormWatcherSaga(),
		//sampleName
		getSampleNameWatcherSaga(),
		// createSampleNameWatcherSaga(),
		deleteSampleNameWatcherSaga(),
		// updateSampleNameWatcherSaga(),
		//pages
		getmenuWatcherSaga(),
		getpagesWatcherSaga(),
		createpagesWatcherSaga(),
		deletepagesWatcherSaga(),
		updatepagesWatcherSaga(),
		createNewVersionpagesWatcherSaga(),

		// column list
		getcolumnListWatcherSaga(),

		//samplelist

		getsamplelistWatcherSaga(),
		deleteSampleListWatcherSaga(),
		updateSampleNameWatcherSaga(),

		//roles and permisswion
		getrolesandpermissionWatcherSaga(),
		deleterolesandpermissionWatcherSaga(),
		//service
		getservicesWatcherSaga(),
		deleteservicesWatcherSaga(),

		//customer oreder
		getcustomerOrderWatcherSaga(),
		deletecustomerOrderWatcherSaga(),

		//workorder
		getworkOrderWatcherSaga(),
		deleteworkOrderWatcherSaga(),

		//mangejob
		getManageJobWatcherSaga(),
		deleteManageJobWatcherSaga(),

		getjobWatcherSaga(),
		getMasterJobWatcherSaga(),

		getdataEntryWatcherSaga(),

		//equipment service

		getequipmetsServiceWatcherSaga(),
		createequipmetsServiceWatcherSaga(),
		deleteequipmetsServiceWatcherSaga(),
		updateequipmetsServiceWatcherSaga(),

		//expired items
		getexpiredItemsWatcherSaga(),
		deleteexpiredItemsWatcherSaga(),
		//ReagentsAndChemicals
		getreagentsWatcherSaga(),
		deletereagentsWatcherSaga(),

		//CRM
		getcrmWatcherSaga(),
		deletecrmWatcherSaga(),

		//store
		getstoreWatcherSaga(),
		deletestoreWatcherSaga(),

		//report
		getreportsWatcherSaga(),

		//groups
		getgroupsWatcherSaga(),
		getmanageGroupsWatcherSaga(),
		getGroupTechnicianListsWatcherSaga(),
		//calibration
		getCalibrationWatcherSaga(),
		deleteCalibrationWatcherSaga(),
		//maintenance
		getMaintenanceWatcherSaga(),
		deleteMaintenanceWatcherSaga(),
		//technician
		getTechnicianWatcherSaga(),
		deleteTechnicianWatcherSaga(),

		//  REPORT BUILDER RELATED WATCHER SAGAS
		//Subscriber
		getsubscriberWatcherSaga(),
		deletesubscriberWatcherSaga(),

		// SubscriptionPlan
		getsubscriptionplanWatcherSaga(),
		deletesubscriptionplanWatcherSaga(),

		//contentpage
		getcontentPageWatcherSaga(),
		deletecontentPageWatcherSaga(),

		//cmspagelist
		getCmsPageListWatcherSaga(),
		deleteCmsPageListWatcherSaga(),

		//site setting

		getsiteSettingWatcherSaga(),
		deletesiteSettingWatcherSaga(),
		//  REPORT BUILDER RELATED WATCHER SAGAS

		//general Inventory
		getgeneralInventoryWatcherSaga(),
		deletegeneralInventoryWatcherSaga(),

		//userProfile
		getuserProfileWatcherSaga(),
		deleteuserProfileWatcherSaga(),

		//employeeformlist
		getEmployeeFormBuilderWatcherSaga(),

		//employedetails
		getEmployeeDetailsWatcherSaga(),
		deleteEmployeeDetailsWatcherSaga(),

		//nonconformity
		getNonConfirmityReportWatcherSaga(),
		getOneNonConformityReportWatcherSaga(),
		deleteNonConfirmityReportWatcherSaga(),

		//nonconformityreview
		getNonConfirmityReportTicketWatcherSaga(),
		deleteNonConfirmityReportTicketWatcherSaga(),

		createTemplateStartWatcherSaga(),
		templateListStartWatcherSaga(),
		deleteTemplateStartWatcherSaga(),
		templateDetailsStartWatcherSaga(),
		updateTemplateStartWatcherSaga(),
		generatePdfAndSendEmailStartWatcherSaga(),
		duplicateTemplateStartWatcherSaga(),

		// Entity related sagas
		getEntityListStartWatcherSaga(),
		getEntityByIdStartWatcherSaga(),
		addRuleToEntityStartWatcherSaga(),
		updateRuleStartWatcherSaga(),

		// Archieve related sagas
		archieveBulkStartWatcherSaga(),

		//acodomation
		getAccommodationWatcherSaga(),
		deleteAccommodationWatcherSaga(),

		//building
		getBuildingWatcherSaga(),
		deleteBuildingWatcherSaga(),

		getClientDetailsWatcherSaga(),
		deleteClientDetailsWatcherSaga(),

		//vendor
		getvendorWatcherSaga(),
		deletevendorWatcherSaga(),

		//vendorformlist
		getVendorFormBuilderWatcherSaga(),
		//vendorDetails
		getVendorDetailsWatcherSaga(),
		deleteVendorDetailsWatcherSaga(),
		//aprovallist
		getapprovalListWatcherSaga(),
		deleteapprovalListWatcherSaga(),
		//vendor categories
		getvendorCategoriesWatcherSaga(),
		deletevendorCategoriesWatcherSaga(),
		getsampleCategoriesWatcherSaga(),
		deletesampleCategoriesWatcherSaga(),
		getvendorSubCategoriesWatcherSaga(),
		deletevendorSubCategoriesWatcherSaga(),

		//document
		getdocumentsWatcherSaga(),
		deletedocumentsWatcherSaga(),

		//document calibration
		getDocumentCalibrationWatcherSaga(),
		deleteDocumentCalibrationWatcherSaga(),
		//document maintenance
		getDocumentMaintenanceWatcherSaga(),
		deleteDocumentMaintenanceWatcherSaga(),
		//customer report
		getCustomReportWatcherSaga(),
		deleteCustomReportWatcherSaga(),
		//quality managment
		getQualityManagmentWatcherSaga(),
		deleteQualityManagmentWatcherSaga(),
		//subquality
		getSubQualityManagmentWatcherSaga(),
		deleteSubQualityManagmentWatcherSaga(),

		//quality manual
		getQuality_ManualWatcherSaga(),
		deleteQuality_ManualWatcherSaga(),

		//User Activity
		userActivityDetailsStartWatcherSaga(),
		userActivityListStartWatcherSaga(),

		//Genaral Doc
		getTechnicalDocumentWatcherSaga(),
		deleteTechnicalDocumentWatcherSaga(),
		getStandardDocumentWatcherSaga(),
		deleteStandardDocumentWatcherSaga(),
		getGeneralDocumentWatcherSaga(),
		deleteGeneralDocumentWatcherSaga(),
		getPrivateDocumentWatcherSaga(),
		deletePrivateDocumentWatcherSaga(),

		//master name list
		getMasterNameListWatcherSaga(),
		deleteMasterNameListWatcherSaga(),

		//lead customer
		getLeadCustomerWatcherSaga(),
		deleteLeadCustomerWatcherSaga(),

		//Requests
		getRequestWatcherSaga(),
		deleteRequestWatcherSaga(),
		updateRequestWatcherSaga(),

		//LabVisitors
		getLabVisitorWatcherSaga(),
		deleteLabVisitorWatcherSaga(),
		updateLabVisitorWatcherSaga(),

		//Logs
		getLogWatcherSaga(),
		deleteLogWatcherSaga(),

		//Po
		getPoWatcherSaga(),
		deletePoWatcherSaga(),
		updatePoWatcherSaga(),

		//Quotation
		getQuotationWatcherSaga(),
		deleteQuotationWatcherSaga(),
		updateQuotationWatcherSaga(),
		//client document list
		getDocumentListWatcherSaga(),
		deleteDocumentListWatcherSaga(),

		//Method Packages
		getMethodPackagesWatcherSaga(),
		deleteMethodPackagesWatcherSaga(),
		getMethodPackagesFormWatcherSaga(),
		updateMethodPackagesFormWatcherSaga(),
		//admin users
		getadminUserWatcherSaga(),
		deleteadminUserWatcherSaga(),
		//managment review
		getmanagementReviewWatcherSaga(),
		deletemanagementReviewWatcherSaga(),
		//internalAudit
		getinternalAuditWatcherSaga(),
		deleteinternalAuditWatcherSaga(),
		//externalAudit
		getexternalAuditWatcherSaga(),
		deleteexternalAuditWatcherSaga(),
		//traning
		gettraningWatcherSaga(),
		deletetraningWatcherSaga(),
		//planTraining
		getplanTrainingWatcherSaga(),
		deleteplanTrainingWatcherSaga(),
		//manage praticipants
		getmanage_participantsWatcherSaga(),
		deletemanage_participantsWatcherSaga(),

		//intra lab program

		getintraLabProgramWatcherSaga(),
		deleteintraLabProgramWatcherSaga(),

		//inter lab program
		getinterLabProgramWatcherSaga(),
		deleteinterLabProgramWatcherSaga(),

		getptProgramWatcherSaga(),
		deleteptProgramWatcherSaga(),

		getcomplainWatcherSaga(),
		deletecomplainWatcherSaga(),

		getsuggestionWatcherSaga(),
		deletesuggestionWatcherSaga(),

		getcustomer_surveyWatcherSaga(),
		deletecustomer_surveyWatcherSaga(),
		getemployee_evaluationWatcherSaga(),
		deleteemployee_evaluationWatcherSaga(),

		getvendor_evaluationWatcherSaga(),
		deletevendor_evaluationWatcherSaga(),

		getequipment_evaluationWatcherSaga(),
		deleteequipment_evaluationWatcherSaga(),
		getrecurringsurveyWatcherSaga(),
		deleterecurringsurveyWatcherSaga(),

		//CalibrationDevices
		getcalibrationdevicesWatcherSaga(),
		deletecalibrationdevicesWatcherSaga(),

		//
		getOrganizationProfileFormBuilderWatcherSaga(),
		getPublicProfileFormBuilderWatcherSaga(),

		// equipment form list
		getEquipmentFormBuilderWatcherSaga(),

		// customer evaluation
		getclient_evaluationWatcherSaga(),
		deleteclient_evaluationWatcherSaga(),

		// client projects
		getclient_projectsWatcherSaga(),
		deleteclient_projectsWatcherSaga(),

		//Client Request
		getClientRequestWatcherSaga(),
		deleteClientRequestWatcherSaga(),
		getSingleClientRequestWatcherSaga(),

	]);
}
